import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import {
  OrganizationMipsSubmissionStatus,
  BlockOrganizationRequest,
  BulkBlockOrganizationsRequest,
} from '@models/mips-submission-block.model';

@Injectable({
  providedIn: 'root',
})
export class MipsSubmissionBlockService {
  private readonly baseUrl = `${environment.apiUrl}/MipsSubmissionBlock`;

  constructor(private http: HttpClient) {}

  getOrganizationStatuses(): Observable<OrganizationMipsSubmissionStatus[]> {
    return this.http.get<OrganizationMipsSubmissionStatus[]>(this.baseUrl);
  }

  blockOrganization(request: BlockOrganizationRequest): Observable<OrganizationMipsSubmissionStatus> {
    return this.http.post<OrganizationMipsSubmissionStatus>(`${this.baseUrl}/block`, request);
  }

  unblockOrganization(organizationId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/block/${organizationId}`);
  }

  bulkBlockOrganizations(request: BulkBlockOrganizationsRequest): Observable<OrganizationMipsSubmissionStatus[]> {
    return this.http.post<OrganizationMipsSubmissionStatus[]>(`${this.baseUrl}/bulk-block`, request);
  }
}
